import { APICore } from './apiCore';

const api = new APICore();


/* CREATE REPLY */
export function Report_Register(data: any): Promise<any> {
    return api.create('/report_register', data);
}

/* LIST */
export function list_Report_Register() {
    return api.show('/report_register/show');
}

/* DETAILS */

export function delete_Report_Register(id: string) {
    return api.get(`/report_register/${id}`);
}

/* UPDATE */
export function update_Report_Register(id: number, data: FormData) {
    return api.create(`/report_register/${id}`, data);
}
